import common from "./common";
import terms from "./terms-conditions";
import privacyPolicy from "./privacy-policy";

export default {
  ...common,
  terms: { ...terms },
  privacy: { ...privacyPolicy },
};
